import { BubbleConfig, CasinoTitleColors } from '../unlock-casino/types/unlock-casino.types';

export const DEFAULT_BUBBLE_CONFIG: BubbleConfig = {
  maxWidth: 700,
  bgColor: '#5e1fa2',
  borderColor: '#ffffff',
  borderWidth: 2,
  borderRadius: 100,
  padding: 25,
  tailSize: 35,
  tailBase: 45,
  glowColor: '#eb39ff',
  glowSpread: 12,
  glowOpacity: 1,
  innerGlowColor: '#bb2ccb',
  innerGlowSpread: 4,
  innerGlowOpacity: 1,
  strokeGlowSpread: 2,
  strokeGlowOpacity: 1,
};

export const DEFAULT_CASINO_TITLE_THEME: CasinoTitleColors = {
  gradientTop: '#fffff1',
  gradientMid: '#ffc803',
  gradientBot: '#f39608',
  strokeColor: '#3D0000',
  blobColor: '#5765fb',
  shadowColor: '#091357',
};

export const CASINO_TITLE_THEMES: Record<number, CasinoTitleColors> = {
  1: {
    gradientTop: '#FFEDFE',
    gradientMid: '#FC6DB6',
    gradientBot: '#F24099',
    strokeColor: '#600C60',
    blobColor: '#5EC0FE',
    shadowColor: '#0C0C5D',
  },
  2: {
    gradientTop: '#FFFAF6',
    gradientMid: '#FEF170',
    gradientBot: '#E8A51E',
    strokeColor: '#551704',
    blobColor: '#FE4D55',
    shadowColor: '#600D0F',
  },
  3: {
    gradientTop: '#FEFCEF',
    gradientMid: '#FFA80D',
    gradientBot: '#EF6506',
    strokeColor: '#691901',
    blobColor: '#FDDD74',
    shadowColor: '#5B310B',
  },
  4: {
    gradientTop: '#FFFFFF',
    gradientMid: '#A0D8EF',
    gradientBot: '#2B90D9',
    strokeColor: '#003366',
    blobColor: '#B3E5FC',
    shadowColor: '#01579B',
  },
  5: {
    gradientTop: '#FFFFF1',
    gradientMid: '#FFC803',
    gradientBot: '#F39608',
    strokeColor: '#3D0000',
    blobColor: '#5765FB',
    shadowColor: '#091357',
  },
  6: {
    gradientTop: '#EEFCFE',
    gradientMid: '#8CBEFE',
    gradientBot: '#8353FF',
    strokeColor: '#53027A',
    blobColor: '#BF1AFB',
    shadowColor: '#3A0B61',
  },
  7: {
    gradientTop: '#FFFDD6',
    gradientMid: '#FFE75D',
    gradientBot: '#EEB424',
    strokeColor: '#3C0B03',
    blobColor: '#A03201',
    shadowColor: '#5C130B',
  },
  8: {
    gradientTop: '#FEF3D5',
    gradientMid: '#FECE77',
    gradientBot: '#FC8D37',
    strokeColor: '#5E0402',
    blobColor: '#9200A2',
    shadowColor: '#500D65',
  },
  9: {
    gradientTop: '#F8F0DC',
    gradientMid: '#FDB762',
    gradientBot: '#FE8B35',
    strokeColor: '#651C06',
    blobColor: '#27E6EE',
    shadowColor: '#0E5D63',
  },
  10: {
    gradientTop: '#FBF054',
    gradientMid: '#FEE401',
    gradientBot: '#E88902',
    strokeColor: '#520F10',
    blobColor: '#FAB8FF',
    shadowColor: '#931596',
  },
  11: {
    gradientTop: '#FEF7C9',
    gradientMid: '#FEE90E',
    gradientBot: '#FEA502',
    strokeColor: '#5B0802',
    blobColor: '#A6E743',
    shadowColor: '#2A5D0B',
  },
  12: {
    gradientTop: '#FEF7C9',
    gradientMid: '#FEE90E',
    gradientBot: '#FEA502',
    strokeColor: '#5B0802',
    blobColor: '#14CC31',
    shadowColor: '#431206',
  },
  13: {
    gradientTop: '#9BE1FF',
    gradientMid: '#70C9FF',
    gradientBot: '#30ADFD',
    strokeColor: '#2D1379',
    blobColor: '#FD4EE1',
    shadowColor: '#6F0453',
  },
  14: {
    gradientTop: '#FEF7C9',
    gradientMid: '#FEE90E',
    gradientBot: '#FEA502',
    strokeColor: '#5B0802',
    blobColor: '#FF871C',
    shadowColor: '#804203',
  },
  15: {
    gradientTop: '#FEE8C4',
    gradientMid: '#FFAF3E',
    gradientBot: '#E97F0D',
    strokeColor: '#7D0521',
    blobColor: '#FF6366',
    shadowColor: '#8D441A',
  },
  16: {
    gradientTop: '#FEF3FD',
    gradientMid: '#FE94EA',
    gradientBot: '#FD64DB',
    strokeColor: '#701051',
    blobColor: '#8C9CB5',
    shadowColor: '#2A4067',
  },
  17: {
    gradientTop: '#FDAD6A',
    gradientMid: '#FF7E4B',
    gradientBot: '#F96334',
    strokeColor: '#7B1705',
    blobColor: '#FFD336',
    shadowColor: '#4D0608',
  },
  18: {
    gradientTop: '#FEF7C9',
    gradientMid: '#FEE90E',
    gradientBot: '#FEA502',
    strokeColor: '#5B0802',
    blobColor: '#5696E0',
    shadowColor: '#024294',
  },
  19: {
    gradientTop: '#FED54C',
    gradientMid: '#FFA502',
    gradientBot: '#F87401',
    strokeColor: '#5B0202',
    blobColor: '#FF6476',
    shadowColor: '#8E192B',
  },
  20: {
    gradientTop: '#FEF7C9',
    gradientMid: '#FEE90E',
    gradientBot: '#FEA502',
    strokeColor: '#5B0802',
    blobColor: '#5CDEFF',
    shadowColor: '#0C285D',
  },
};
